import { Component } from '@angular/core';

@Component({
  selector: 'rs-email',
  templateUrl: 'email.component.html',
  styleUrls: ['email.component.scss']
})
export class EmailComponent {}
